import React from 'react';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <div>© {year} Multiservice</div>
        <div className="footer-links">
          <a href="#services">Services</a>
          <a href="#realisations">Réalisations</a>
          <a href="#contact">Devis</a>
        </div>
      </div>
    </footer>
  );
}
